import React from 'react';
import { toast } from 'react-toastify';

export const showErrorToast = () => {
	const subdomain = window.location.hostname.split('.')[0];
	return toast.error(
		<div>
			{sessionStorage.getItem('i18nextLng') === 'en'
				? 'Error processing request. Please try again or contact'
				: 'Error al procesar la solicitud. Inténtalo de nuevo o contáctanos.'}{' '}
			<a
				href='mailto:datasales@edenbray.com'
				target='_blank'
				rel='noopener noreferrer'
				style={{ color: '#fff' }}>
				{'sales@novusloyalty.com'}{' '}
			</a>
		</div>,
		{
			toastId: 'error_toast',
		},
	);
};
